module.exports = "/_next/static/images/77fa03760608e2c7f1de0a0cf5bc694f-card-and-phone-3d-xs@1x.jpg.webp";